var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.951 8.692a.527.527 0 01-.138.18l-3.35 2.97c-.261.216-.463.074-.463-.34V9H3.5a.5.5 0 010-1H9V5.438c0-.416.214-.556.462-.331l3.351 2.96a.527.527 0 01.138.625z",
    fill: "#A8A8A8"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45NTExIDguNjkxNzFDMTIuOTE4OSA4Ljc2MTI0IDEyLjg3MTkgOC44MjI5MiAxMi44MTM0IDguODcyNDZMOS40NjIyMSAxMS44NDI0QzkuMjAxNzQgMTIuMDU3NyA5IDExLjkxNjQgOSAxMS41MDE5VjguOTk5OTNIMy41QzMuMjIzODYgOC45OTk5MyAzIDguNzc2MDcgMyA4LjQ5OTkzQzMgOC4yMjM3OCAzLjIyMzg2IDcuOTk5OTMgMy41IDcuOTk5OTNIOUw5IDUuNDM3ODFDOSA1LjAyMTU2IDkuMjEzNjUgNC44ODE5NyA5LjQ2MjIxIDUuMTA2NjlMMTIuODEzNCA4LjA2NzIxQzEyLjg3MTkgOC4xMTY3NiAxMi45MTg5IDguMTc4NDQgMTIuOTUxMSA4LjI0Nzk3QzEyLjk4MzMgOC4zMTc1IDEzIDguMzkzMjEgMTMgOC40Njk4NEMxMyA4LjU0NjQ3IDEyLjk4MzMgOC42MjIxOCAxMi45NTExIDguNjkxNzFaIiBmaWxsPSIjQThBOEE4Ii8+Cjwvc3ZnPgo=";
export { SvgSmallArrow as ReactComponent };